import React from 'react';
import { Menu, MoreVertical, Heart } from 'lucide-react';

interface HeaderProps {
  onMenuClick?: () => void;
  onSettingsClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, onSettingsClick }) => {
  return (
    <header className="bg-gray-800 text-white">
      {/* macOS-style window controls (for desktop app) */}
      <div className="flex items-center justify-between px-4 py-3">
        {/* Left side - Menu */}
        <button
          onClick={onMenuClick}
          className="p-2 hover:bg-gray-700 rounded-lg transition-colors"
          title="Menu"
        >
          <Menu className="w-5 h-5" />
        </button>

        {/* Center - App Title */}
        <div className="flex items-center space-x-2">
          <Heart className="w-5 h-5 text-megi-red" />
          <h1 className="text-lg font-bold">MEGI</h1>
        </div>

        {/* Right side - Settings */}
        <button
          onClick={onSettingsClick}
          className="p-2 hover:bg-gray-700 rounded-lg transition-colors"
          title="Settings"
        >
          <MoreVertical className="w-5 h-5" />
        </button>
      </div>
    </header>
  );
};

export default Header;